import { Alert, Button } from '30pay/components';
import { Radio, Spin } from 'antd';
import { BankAccount } from 'interfaces';
import { useEffect, useState } from 'react';
import { BsChevronDown } from 'react-icons/bs';
import { detectBankByName } from 'scripts';
import { Card } from 'utilities/components';
import { HiArrowLeft, HiArrowRight } from 'react-icons/hi2';
import { ConvertBoxDataType } from '../convertBox.index';
import { __TypeOfOrderEnum } from '../initial/initial.interface';
import { IBanSelectionModal } from '30pay/wallet/deposit/iBanSelectionModal/iBanSelectionModal.index';
import { getIBans } from 'services';
import { __SellWithdrawMethodConvertBoxProps, __SellWithdrawMethodsEnums } from './sellWithdrawMethod.interface';

const SellWithdrawMethod: React.FC<__SellWithdrawMethodConvertBoxProps> = (
    props: __SellWithdrawMethodConvertBoxProps,
) => {
    const [withdrawMethod, setWithdrawMethod] = useState<__SellWithdrawMethodsEnums>(__SellWithdrawMethodsEnums.iBan);
    const [iBansLoading, setIBansLoading] = useState(true);
    const [iBans, setIBans] = useState<Omit<BankAccount, 'cardNumber'>[]>();
    const [selectedIBan, setSelectedIBan] = useState<Omit<BankAccount, 'cardNumber'>>();
    const [iBansModalOpen, setIBansModalOpen] = useState<boolean>(false);

    useEffect(() => {
        getIBans(setIBansLoading, setIBans, setSelectedIBan);
    }, []);

    function submitHandler() {
        const output: ConvertBoxDataType = {
            bankAccountId: selectedIBan?.id,
            withdrawMethod,
        };
        props.onSubmit(output);
    }

    function backHandler() {
        props.onBack();
    }

    const onIBanSelection = (iBan: Omit<BankAccount, 'cardNumber'>) => {
        setSelectedIBan(iBan);
        setIBansModalOpen(false);
    };

    return (
        <div className="flex max-lg:flex-col gap-6 h-full">
            <Card className="flex-1" title="روش دریافت" titleDivider>
                {iBans && (
                    <IBanSelectionModal
                        open={iBansModalOpen}
                        setOpen={setIBansModalOpen}
                        iBans={iBans}
                        onSelect={onIBanSelection}
                    />
                )}
                <div className="flex flex-col gap-6">
                    <Radio.Group
                        buttonStyle="solid"
                        onChange={(e) => setWithdrawMethod(e.target.value)}
                        value={withdrawMethod}
                    >
                        <Radio value={__SellWithdrawMethodsEnums.wallet}>شارژ کیف پول</Radio>
                        <Radio value={__SellWithdrawMethodsEnums.iBan}>دریافت مستقیم با شماره شبا</Radio>
                    </Radio.Group>
                    {withdrawMethod === __SellWithdrawMethodsEnums.iBan && (
                        <div>
                            <label className={'max-lg:text-sm'}>شماره شبا:</label>
                            <Spin spinning={iBansLoading}>
                                <div
                                    className={
                                        'flex justify-between items-center border border-primary-40 rounded-[28px] text-base px-6 h-14 w-full max-lg:h-12 max-lg:text-sm mt-2 clickable'
                                    }
                                    onClick={() => setIBansModalOpen(true)}
                                >
                                    {!iBansLoading &&
                                        (selectedIBan ? (
                                            <>
                                                <div className={'flex items-center gap-4'}>
                                                    <img
                                                        src={detectBankByName(selectedIBan?.bank?.name)?.bank_logo}
                                                        className={'w-6 h-6'}
                                                    />
                                                    {selectedIBan?.bank?.name}
                                                </div>
                                                {selectedIBan?.iBan}
                                                <BsChevronDown />
                                            </>
                                        ) : (
                                            <p className="text-sm mx-auto font-medium text-darkPurple-40">
                                                برای انتخاب کارت کلیک کنید
                                            </p>
                                        ))}
                                </div>
                            </Spin>
                        </div>
                    )}
                </div>

                <div className="flex items-center w-full gap-4 mt-6">
                    <Button disabled={!selectedIBan} onClick={submitHandler} className="w-full h-16" type="primary">
                        <HiArrowRight />
                        ادامه
                    </Button>
                    <Button onClick={backHandler} className="w-full h-16 bg-background" type="text">
                        بازگشت
                        <HiArrowLeft />
                    </Button>
                </div>
            </Card>
            <div className="flex flex-col gap-6 flex-1">
                <Alert
                    title="روش شارژ کیف پول:"
                    message="در این روش پس از پرداخت، ارز به صورت خودکار به کیف پول موجود در پنل کاربری شما اضافه خواهد شد."
                    variant="info"
                />
                <Alert
                    title="دریافت مستقیم با شماره شبا:"
                    message="در این روش پس از وارد کردن شماره شبای خود،معادل تومانی رمز ارز فروخته شده را دریافت می کنید."
                    variant="info"
                />
            </div>
        </div>
    );
};
export default SellWithdrawMethod;
